'use client'

import React, { useState, useEffect, useRef } from 'react';
import AnimatedOrb from './AnimatedOrb';
import BottomChatNav, { BottomNavState } from './BottomChatNav';

interface Message {
  id: string;
  type: 'initial' | 'with-glow' | 'with-glow-chat' | 'chat-collapsed' | 'ai' | 'ai-with-chart' | 'ai-with-comparison-chart' | 'ai-with-gap-chart' | 'ai-with-home-chart' | 'ai-with-timeline' | 'ai-with-spending-breakdown' | 'user' | 'ai-final';
  content?: string;
  thinking?: boolean;
}

// Individual message components
const AIMessage = ({ message }: { message: Message }) => (
  <div className="max-w-[90%] animate-in fade-in slide-in-from-bottom-4 duration-500" key={message.id}>
    <div className="text-[11px] text-night leading-snug">
      {message.content}
            </div>
          </div>
        );
      
const ThinkingIndicator = () => (
  <div className="flex items-center gap-2 animate-in fade-in slide-in-from-bottom-4 duration-500">
                <div className="w-6 h-6">
                  <AnimatedOrb size={24} className="w-full h-full" />
                </div>
                <div className="text-night text-lg">...</div>
          </div>
        );
      
const AIWithChart = ({ message }: { message: Message }) => (
  <div className="max-w-[95%] animate-in fade-in slide-in-from-bottom-4 duration-700" key={message.id}>
                <div className="text-xs text-night leading-relaxed mb-2">
      {message.content}
                </div>
                <div className="mt-2">
                  <svg width="226" height="88" viewBox="0 0 226 88" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
                    <path d="M14.156 28H13.58L13.58 19.48H14.156L17.42 27.304L20.672 19.48H21.26V28H20.684V23.332C20.684 21.94 20.708 21.22 20.744 20.656L17.708 28H17.132L14.096 20.692C14.12 20.932 14.156 21.928 14.156 23.332V28ZM22.622 21.628C22.622 20.236 23.714 19.336 25.394 19.336C26.858 19.336 27.83 20.152 27.998 21.52H27.398C27.278 20.464 26.558 19.864 25.394 19.864C24.074 19.864 23.198 20.56 23.198 21.628C23.198 22.444 23.69 22.984 24.662 23.236L26.174 23.62C27.458 23.944 28.142 24.712 28.142 25.804C28.142 27.232 27.038 28.144 25.334 28.144C23.738 28.144 22.658 27.316 22.526 25.984H23.138C23.186 26.956 24.062 27.604 25.334 27.604C26.69 27.604 27.566 26.908 27.566 25.816C27.566 24.976 27.074 24.412 26.066 24.16L24.59 23.788C23.306 23.464 22.622 22.732 22.622 21.628ZM32.9874 28.132C30.6594 28.132 29.0394 26.332 29.0394 23.74C29.0394 21.136 30.6714 19.336 33.0354 19.336C34.7754 19.336 36.1914 20.416 36.5634 22.036H35.9274C35.5434 20.716 34.4154 19.888 32.9994 19.888C30.9954 19.888 29.6274 21.448 29.6274 23.74C29.6274 26.032 30.9954 27.58 32.9994 27.58C34.4154 27.58 35.5794 26.788 35.9754 25.564H36.6114C36.2034 27.1 34.7394 28.132 32.9874 28.132ZM38.5652 19.48V28H37.9892V19.48H38.5652ZM45.343 28L42.823 19.48L43.423 19.48L45.319 25.936C45.427 26.32 45.523 26.728 45.631 27.22C45.775 26.656 45.883 26.32 46.003 25.936L48.079 19.48H48.655L50.743 25.936C50.875 26.332 50.983 26.74 51.103 27.208C51.223 26.62 51.331 26.212 51.415 25.936L53.335 19.48H53.923L51.379 28H50.851L48.367 20.32L45.895 28H45.343ZM53.8062 25.12C53.8062 23.38 55.0182 22.096 56.6622 22.096C58.3062 22.096 59.5182 23.38 59.5182 25.12C59.5182 26.86 58.3062 28.144 56.6622 28.144C55.0182 28.144 53.8062 26.86 53.8062 25.12ZM54.3702 25.12C54.3702 26.596 55.3182 27.64 56.6622 27.64C58.0062 27.64 58.9542 26.596 58.9542 25.12C58.9542 23.644 58.0062 22.6 56.6622 22.6C55.3182 22.6 54.3702 23.644 54.3702 25.12ZM63.4742 22.156V22.636H63.0422C61.9742 22.636 61.2782 23.416 61.2782 24.496V28H60.7262V22.24H61.2422L61.2902 23.164C61.5182 22.516 62.1542 22.096 62.9702 22.096C63.1502 22.096 63.2822 22.108 63.4742 22.156ZM65.0486 28H64.4966V19.336H65.0486V28ZM68.9612 28.144C67.2692 28.144 66.3092 26.824 66.3092 25.12C66.3092 23.416 67.2692 22.096 68.9612 22.096C69.9812 22.096 70.7732 22.552 71.1932 23.488V19.336H71.7452V28H71.3012L71.2172 26.704C70.7852 27.688 69.9572 28.144 68.9612 28.144ZM69.0212 27.64C70.4012 27.64 71.1812 26.584 71.1812 25.12C71.1812 23.668 70.4012 22.6 69.0212 22.6C67.6532 22.6 66.8732 23.668 66.8732 25.12C66.8732 26.584 67.6532 27.64 69.0212 27.64ZM74.1013 23.428C73.7413 23.428 73.4413 23.128 73.4413 22.78C73.4413 22.42 73.7413 22.12 74.1013 22.12C74.4613 22.12 74.7613 22.42 74.7613 22.78C74.7613 23.128 74.4613 23.428 74.1013 23.428ZM74.1013 28.132C73.7413 28.132 73.4413 27.832 73.4413 27.484C73.4413 27.124 73.7413 26.824 74.1013 26.824C74.4613 26.824 74.7613 27.124 74.7613 27.484C74.7613 27.832 74.4613 28.132 74.1013 28.132ZM79.6789 23.692H82.4149V20.956H82.9429V23.692H85.6789V24.22H82.9429V26.968H82.4149V24.22H79.6789V23.692ZM86.5808 19.48H92.2208V20.008L88.7648 28H88.1648L91.6448 20.008H86.5808V19.48ZM92.7064 25.72C92.7064 24.664 93.3664 23.824 94.4104 23.476C93.5104 23.116 93.0064 22.396 93.0064 21.496C93.0064 20.212 94.0744 19.336 95.6464 19.336C97.2064 19.336 98.2624 20.212 98.2624 21.496C98.2624 22.42 97.7584 23.14 96.8704 23.476C97.9024 23.776 98.5744 24.64 98.5744 25.732C98.5744 27.148 97.3744 28.144 95.6464 28.144C93.9064 28.144 92.7064 27.148 92.7064 25.72ZM93.5704 21.472C93.5704 22.516 94.3984 23.212 95.6464 23.212C96.8944 23.212 97.6984 22.54 97.6984 21.496C97.6984 20.5 96.8944 19.864 95.6464 19.864C94.3984 19.864 93.5704 20.5 93.5704 21.472ZM93.2704 25.66C93.2704 26.824 94.2424 27.616 95.6584 27.616C97.0504 27.616 98.0104 26.824 98.0104 25.672C98.0104 24.52 97.0744 23.764 95.6344 23.764C94.2064 23.764 93.2704 24.52 93.2704 25.66ZM103.754 21.376C103.754 22.564 102.902 23.428 101.726 23.428C100.55 23.428 99.698 22.564 99.698 21.376C99.698 20.188 100.55 19.324 101.726 19.324C102.902 19.324 103.754 20.188 103.754 21.376ZM107.918 19.48L101.45 28H100.826L107.282 19.48H107.918ZM103.226 21.376C103.226 20.464 102.614 19.828 101.726 19.828C100.838 19.828 100.226 20.464 100.226 21.376C100.226 22.288 100.85 22.924 101.726 22.924C102.602 22.924 103.226 22.288 103.226 21.376ZM109.058 26.104C109.058 27.292 108.206 28.156 107.03 28.156C105.854 28.156 105.002 27.292 105.002 26.104C105.002 24.916 105.854 24.052 107.03 24.052C108.206 24.052 109.058 24.916 109.058 26.104ZM108.53 26.104C108.53 25.192 107.918 24.556 107.03 24.556C106.142 24.556 105.53 25.192 105.53 26.104C105.53 27.016 106.154 27.652 107.03 27.652C107.906 27.652 108.53 27.016 108.53 26.104ZM12.896 42.44H13.436C13.436 43.184 13.988 43.64 14.876 43.64C15.848 43.64 16.448 43.208 16.448 42.5C16.448 41.936 16.172 41.648 15.428 41.456L14.456 41.204C13.472 40.952 13.004 40.4 13.004 39.692C13.004 38.732 13.796 38.096 14.984 38.096C16.172 38.096 16.916 38.732 16.952 39.776H16.412C16.376 39.032 15.848 38.6 14.984 38.6C14.06 38.6 13.556 38.984 13.556 39.692C13.556 40.184 13.892 40.532 14.588 40.712L15.548 40.964C16.556 41.228 17 41.696 17 42.5C17 43.484 16.16 44.144 14.9 44.144C13.676 44.144 12.896 43.484 12.896 42.44ZM18.5705 36.476C18.2945 36.476 18.0665 36.248 18.0665 35.984C18.0665 35.708 18.2945 35.468 18.5705 35.468C18.8345 35.468 19.0745 35.708 19.0745 35.984C19.0745 36.248 18.8345 36.476 18.5705 36.476ZM18.2945 44V38.24H18.8465V44H18.2945ZM21.0454 44H20.4934V38.24H20.9374L21.0574 39.356C21.4414 38.552 22.2334 38.096 23.0974 38.096C24.7294 38.096 25.3414 39.056 25.3414 40.496V44H24.7894V40.604C24.7894 39.08 24.1294 38.6 23.0854 38.6C21.7774 38.6 21.0454 39.572 21.0454 41.024V44ZM26.4791 41.144C26.4791 39.32 27.5591 38.096 29.2151 38.096C30.4511 38.096 31.3751 38.828 31.6391 39.92H31.0751C30.8351 39.068 30.0671 38.588 29.2151 38.588C27.9311 38.588 27.0191 39.572 27.0191 41.132C27.0191 42.62 27.8591 43.64 29.1431 43.64C30.0671 43.64 30.8351 43.112 31.0991 42.332H31.6631C31.3511 43.424 30.3671 44.144 29.1431 44.144C27.5591 44.144 26.4791 42.944 26.4791 41.144ZM35.1531 44.144C33.4851 44.144 32.3811 42.944 32.3811 41.132C32.3811 39.332 33.4731 38.096 35.0811 38.096C36.5811 38.096 37.6131 39.176 37.6131 40.748V41.132H32.9331C32.9811 42.704 33.7971 43.64 35.1531 43.64C36.1731 43.64 36.8211 43.196 37.0491 42.344H37.6131C37.2771 43.532 36.4491 44.144 35.1531 44.144ZM35.0811 38.6C33.9051 38.6 33.0771 39.416 32.9451 40.676H37.0491C37.0491 39.428 36.2691 38.6 35.0811 38.6ZM41.8119 39.74C41.8119 37.088 43.0599 35.324 45.1359 35.324C47.2119 35.324 48.4599 37.088 48.4599 39.74C48.4599 42.392 47.2119 44.156 45.1359 44.156C43.0599 44.156 41.8119 42.392 41.8119 39.74ZM42.3759 39.74C42.3759 42.056 43.3839 43.616 45.1359 43.616C46.8879 43.616 47.8959 42.056 47.8959 39.74C47.8959 37.424 46.8879 35.864 45.1359 35.864C43.3839 35.864 42.3759 37.424 42.3759 39.74ZM51.0978 36.008H49.4178V35.48H51.6618L51.6618 44H51.0978L51.0978 36.008ZM53.2839 44H52.7319L56.0559 35.48H56.6199L53.2839 44ZM62.2787 44H56.8067V43.52L59.5067 41.132C61.2587 39.584 61.6667 38.972 61.6667 37.88C61.6667 36.644 60.8987 35.876 59.6627 35.876C58.3907 35.876 57.5267 36.812 57.4787 38.24H56.9027C56.9627 36.488 58.0667 35.336 59.6867 35.336C61.1987 35.336 62.2427 36.368 62.2427 37.844C62.2427 39.104 61.7267 39.896 59.8427 41.552L57.6707 43.472H62.2787V44ZM63.4161 39.74C63.4161 37.088 64.6641 35.324 66.7401 35.324C68.8161 35.324 70.0641 37.088 70.0641 39.74C70.0641 42.392 68.8161 44.156 66.7401 44.156C64.6641 44.156 63.4161 42.392 63.4161 39.74ZM63.9801 39.74C63.9801 42.056 64.9881 43.616 66.7401 43.616C68.4921 43.616 69.5001 42.056 69.5001 39.74C69.5001 37.424 68.4921 35.864 66.7401 35.864C64.9881 35.864 63.9801 37.424 63.9801 39.74ZM76.614 44H71.142V43.52L73.842 41.132C75.594 39.584 76.002 38.972 76.002 37.88C76.002 36.644 75.234 35.876 73.998 35.876C72.726 35.876 71.862 36.812 71.814 38.24H71.238C71.298 36.488 72.402 35.336 74.022 35.336C75.534 35.336 76.578 36.368 76.578 37.844C76.578 39.104 76.062 39.896 74.178 41.552L72.006 43.472H76.614V44ZM77.7514 39.74C77.7514 37.088 78.9994 35.324 81.0754 35.324C83.1514 35.324 84.3994 37.088 84.3994 39.74C84.3994 42.392 83.1514 44.156 81.0754 44.156C78.9994 44.156 77.7514 42.392 77.7514 39.74ZM78.3154 39.74C78.3154 42.056 79.3234 43.616 81.0754 43.616C82.8274 43.616 83.8354 42.056 83.8354 39.74C83.8354 37.424 82.8274 35.864 81.0754 35.864C79.3234 35.864 78.3154 37.424 78.3154 39.74Z" fill="#091410" fillOpacity="0.6"/>
                    <path d="M0.402832 82.4643C1.51394 82.4643 1.51394 86.7527 2.62505 86.7527C3.73617 86.7527 3.73617 85.8783 4.84728 85.8783C5.95839 85.8783 5.95839 86.6132 7.0695 86.6132C8.18061 86.6132 8.18061 83.348 9.29172 83.348C10.4028 83.348 10.4028 79.2922 11.5139 79.2922C12.6251 79.2922 12.6251 76.055 13.7362 76.055C14.8473 76.055 14.8473 76.3341 15.9584 76.3341C17.0695 76.3341 17.0695 76.455 18.1806 76.455C19.2917 76.455 19.2917 76.7713 20.4028 76.7713C21.5139 76.7713 21.5139 76.8457 22.6251 76.8457C23.7362 76.8457 23.7362 74.8271 24.8473 74.8271C25.9584 74.8271 25.9584 74.7713 27.0695 74.7713C28.1806 74.7713 28.1806 72.8643 29.2917 72.8643C30.4028 72.8643 30.4028 73.9527 31.5139 73.9527C32.6251 73.9527 32.6251 77.2364 33.7362 77.2364C34.8473 77.2364 34.8473 75.8038 35.9584 75.8038C37.0695 75.8038 37.0695 76.3248 38.1806 76.3248C39.2917 76.3248 39.2917 75.748 40.4028 75.748C41.5139 75.748 41.5139 74.5294 42.6251 74.5294C43.7362 74.5294 43.7362 74.6597 44.8473 74.6597C45.9584 74.6597 45.9584 74.9852 47.0695 74.9852C48.1806 74.9852 48.1806 70.1294 49.2917 70.1294C50.4028 70.1294 50.4028 72.4085 51.5139 72.4085C52.6251 72.4085 52.6251 69.3666 53.7362 69.3666C54.8473 69.3666 54.8473 69.4225 55.9584 69.4225C57.0695 69.4225 57.0695 69.3945 58.1806 69.3945C59.2917 69.3945 59.2917 69.2922 60.4028 69.2922C61.5139 69.2922 61.5139 68.0736 62.6251 68.0736C63.7362 68.0736 63.7362 67.9713 64.8473 67.9713C65.9584 67.9713 65.9584 64.6411 67.0695 64.6411C68.1806 64.6411 68.1806 65.1527 69.2917 65.1527C70.4028 65.1527 70.4028 64.1573 71.5139 64.1573C72.625 64.1573 72.625 66.3713 73.7362 66.3713C74.8473 66.3713 74.8473 64.0457 75.9584 64.0457C77.0695 64.0457 77.0695 61.0225 78.1806 61.0225C79.2917 61.0225 79.2917 62.455 80.4028 62.455C81.5139 62.455 81.5139 64.0364 82.6251 64.0364C83.7362 64.0364 83.7362 63.162 84.8473 63.162C85.9584 63.162 85.9584 61.0318 87.0695 61.0318C88.1806 61.0318 88.1806 59.4132 89.2917 59.4132C90.4028 59.4132 90.4028 59.5062 91.5139 59.5062C92.625 59.5062 92.625 58.0364 93.7362 58.0364C94.8473 58.0364 94.8473 57.0504 95.9584 57.0504C97.0695 57.0504 97.0695 55.9341 98.1806 55.9341C99.2917 55.9341 99.2917 56.4178 100.403 56.4178C101.514 56.4178 101.514 54.3155 102.625 54.3155C103.736 54.3155 103.736 52.6876 104.847 52.6876C105.958 52.6876 105.958 54.7062 107.069 54.7062C108.181 54.7062 108.181 53.2643 109.292 53.2643C110.403 53.2643 110.403 50.7899 111.514 50.7899C112.625 50.7899 112.625 54.3527 113.736 54.3527C114.847 54.3527 114.847 51.7573 115.958 51.7573C117.069 51.7573 117.069 52.6225 118.181 52.6225C119.292 52.6225 119.292 51.1155 120.403 51.1155C121.514 51.1155 121.514 52.4829 122.625 52.4829C123.736 52.4829 123.736 52.8457 124.847 52.8457C125.958 52.8457 125.958 54.8178 127.07 54.8178C128.181 54.8178 128.181 54.055 129.292 54.055C130.403 54.055 130.403 55.1899 131.514 55.1899C132.625 55.1899 132.625 51.8411 133.736 51.8411C134.847 51.8411 134.847 50.855 135.958 50.855C137.07 50.855 137.069 50.2132 138.181 50.2132C139.292 50.2132 139.292 50.6504 140.403 50.6504C141.514 50.6504 141.514 47.4783 142.625 47.4783C143.736 47.4783 143.736 46.1108 144.847 46.1108C145.958 46.1108 145.958 46.0271 147.069 46.0271C148.181 46.0271 148.181 41.9713 149.292 41.9713C150.403 41.9713 150.403 42.548 151.514 42.548C152.625 42.548 152.625 41.2364 153.736 41.2364C154.847 41.2364 154.847 40.7527 155.958 40.7527C157.07 40.7527 157.07 42.4364 158.181 42.4364C159.292 42.4364 159.292 40.8271 160.403 40.8271C161.514 40.8271 161.514 36.455 162.625 36.455C163.736 36.455 163.736 37.4225 164.847 37.4225C165.958 37.4225 165.958 38.3155 167.07 38.3155C168.181 38.3155 168.181 40.7527 169.292 40.7527C170.403 40.7527 170.403 42.2597 171.514 42.2597C172.625 42.2597 172.625 39.4783 173.736 39.4783C174.847 39.4783 174.847 36.5945 175.958 36.5945C177.07 36.5945 177.069 34.3899 178.181 34.3899C179.292 34.3899 179.292 32.2876 180.403 32.2876C181.514 32.2876 181.514 30.8271 182.625 30.8271C183.736 30.8271 183.736 28.855 184.847 28.855C185.958 28.855 185.958 31.2364 187.069 31.2364C188.181 31.2364 188.181 30.2411 189.292 30.2411C190.403 30.2411 190.403 28.3062 191.514 28.3062C192.625 28.3062 192.625 26.9387 193.736 26.9387C194.847 26.9387 194.847 27.2178 195.958 27.2178C197.069 27.2178 197.069 27.9992 198.181 27.9992C199.292 27.9992 199.292 27.5062 200.403 27.5062C201.514 27.5062 201.514 24.7806 202.625 24.7806C203.736 24.7806 203.736 20.1666 204.847 20.1666C205.958 20.1666 205.958 17.3015 207.07 17.3015C208.181 17.3015 208.181 17.9155 209.292 17.9155C210.403 17.9155 210.403 15.1806 211.514 15.1806C212.625 15.1806 212.625 17.1341 213.736 17.1341C214.847 17.1341 214.847 16.9387 215.958 16.9387C217.069 16.9387 217.07 15.8038 218.181 15.8038C219.292 15.8038 219.292 14.7527 220.403 14.7527M220.403 14.7527V14.7527Z" stroke="#5D97D1"/>
                  </svg>
                </div>
              </div>
);
              
const AIWithComparisonChart = ({ message, locale }: { message: Message; locale: PhoneLocale }) => {
  const W = 226, H = 100
  const lp = 5, rp = 52, tp = 18, bp = 16
  const pw = W - lp - rp
  const ph = H - tp - bp
  const maxVal = 34700
  const indexVals = [0, 2400, 5000, 7800, 10800, 14100, 17600, 21400, 25500, 30000, 34700]
  const tagesgeldVals = [0, 2450, 4820, 7190, 9580, 12000, 14400, 16900, 19350, 21850, 24900]
  const n = 10
  const px = (i: number) => lp + (i / n) * pw
  const py = (v: number) => tp + ph - (v / maxVal) * ph
  const toPath = (vals: number[]) =>
    vals.map((v, i) => `${i === 0 ? 'M' : 'L'}${px(i).toFixed(1)},${py(v).toFixed(1)}`).join(' ')
  return (
    <div className="max-w-[95%] animate-in fade-in slide-in-from-bottom-4 duration-700">
      <div className="text-[11px] text-night leading-snug mb-2">{message.content}</div>
      <div className="rounded-lg p-2" style={{ background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(9,20,16,0.06)' }}>
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} fill="none" className="w-full h-auto">
          <line x1={lp} y1={tp + ph} x2={lp + pw} y2={tp + ph} stroke="rgba(9,20,16,0.12)" strokeWidth="0.5" />
          {[2,4,6,8,10].map((i) => (
            <text key={i} x={px(i)} y={H - 4} textAnchor="middle" fontSize="6.5" fill="rgba(9,20,16,0.4)">{phoneText(locale, 'Yr')} {i}</text>
          ))}
          <path d={toPath(tagesgeldVals)} stroke="rgba(9,20,16,0.3)" strokeWidth="1.5" />
          <path d={toPath(indexVals)} stroke="#4CAF50" strokeWidth="1.5" />
          <text x={px(10) + 4} y={py(34700) + 4} fontSize="7" fill="#4CAF50" fontWeight="600">€34,700</text>
          <text x={px(10) + 4} y={py(24900) + 4} fontSize="7" fill="rgba(9,20,16,0.5)">€24,900</text>
          <line x1={lp} y1={6} x2={lp + 10} y2={6} stroke="#4CAF50" strokeWidth="1.5" />
          <text x={lp + 13} y={9} fontSize="6" fill="#4CAF50">{phoneText(locale, 'Index fund')}</text>
          <line x1={lp + 58} y1={6} x2={lp + 68} y2={6} stroke="rgba(9,20,16,0.3)" strokeWidth="1.5" />
          <text x={lp + 71} y={9} fontSize="6" fill="rgba(9,20,16,0.4)">Tagesgeld 0.8%</text>
        </svg>
      </div>
    </div>
  )
}

const AIWithGapChart = ({ message, locale }: { message: Message; locale: PhoneLocale }) => (
  <div className="max-w-[95%] animate-in fade-in slide-in-from-bottom-4 duration-700">
    <div className="text-[11px] text-night leading-snug mb-2">{message.content}</div>
    <div className="rounded-lg p-2" style={{ background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(9,20,16,0.06)' }}>
      <svg width="226" height="100" viewBox="0 0 226 100" fill="none" className="w-full h-auto">
        {/* Baseline */}
        <line x1="20" y1="76" x2="206" y2="76" stroke="rgba(9,20,16,0.12)" strokeWidth="0.5" />
        {/* Left bar — projected income (green) */}
        <rect x="35" y="48" width="56" height="28" rx="3" fill="#C5ECAC" />
        {/* Right bar — bottom matching section (green) */}
        <rect x="135" y="48" width="56" height="28" rx="3" fill="#C5ECAC" />
        {/* Right bar — amber gap section */}
        <rect x="135" y="26" width="56" height="22" rx="3" fill="rgba(251,191,36,0.65)" />
        {/* Gap label inside amber */}
        <text x="163" y="40" textAnchor="middle" fontSize="6.5" fill="#92400E" fontWeight="600">{phoneText(locale, 'Gap')}: €1,120/{phoneText(locale, 'mo')}</text>
        {/* Value labels above bars */}
        <text x="63" y="44" textAnchor="middle" fontSize="7.5" fill="#091410" fontWeight="600">€1,480/mo</text>
        <text x="163" y="22" textAnchor="middle" fontSize="7.5" fill="#091410" fontWeight="600">€2,600/mo</text>
        {/* Bottom labels */}
        <text x="63" y="86" textAnchor="middle" fontSize="6" fill="rgba(9,20,16,0.45)">{phoneText(locale, 'Projected income')}</text>
        <text x="163" y="86" textAnchor="middle" fontSize="6" fill="rgba(9,20,16,0.45)">{phoneText(locale, 'Estimated need')}</text>
      </svg>
    </div>
  </div>
)

const AIWithHomeChart = ({ message, locale }: { message: Message; locale: PhoneLocale }) => (
  <div className="max-w-[95%] animate-in fade-in slide-in-from-bottom-4 duration-700">
    <div className="text-[11px] text-night leading-snug mb-2">{message.content}</div>
    <div className="py-1">
      {/* Top labels */}
      <div className="flex justify-between items-end mb-1">
        <span className="text-[8.5px] font-medium" style={{ color: '#5D97D1' }}>{phoneText(locale, '€34k saved')}</span>
        <span className="text-[8.5px] font-medium text-night">{phoneText(locale, '€70k goal')}</span>
      </div>
      {/* Progress bar */}
      <div className="relative h-2 rounded-full" style={{ background: 'rgba(9,20,16,0.08)' }}>
        <div className="absolute left-0 top-0 h-full rounded-full"
             style={{ width: '48.6%', background: 'linear-gradient(to right, #A8E1DF, #5D97D1)' }} />
        <div className="absolute w-3 h-3 rounded-full border-[1.5px] border-white"
             style={{ left: '48.6%', top: '50%', transform: 'translate(-50%, -50%)', background: '#5D97D1', boxShadow: '0 1px 3px rgba(0,0,0,0.15)' }} />
      </div>
    </div>
    <div className="text-[11px] text-night leading-snug mt-1.5">
      {phoneText(locale, "Assuming a €70k down payment and your current savings rate, you'll be in your own home in 4 to 5 years. Almost no time.")}
    </div>
  </div>
)

const AIWithTimeline = ({ message, locale }: { message: Message; locale: PhoneLocale }) => (
  <div className="max-w-[95%] animate-in fade-in slide-in-from-bottom-4 duration-700" key={message.id}>
    <div className="text-xs text-night leading-relaxed mb-2">
      {message.content}
    </div>
    <div className="rounded-lg p-2" style={{ background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(9,20,16,0.06)' }}>
      <div className="flex justify-between text-[8px] mb-1" style={{ color: 'rgba(9,20,16,0.45)' }}>
        <span>{phoneText(locale, 'Today')}</span>
        <span className="font-medium" style={{ color: '#5D97D1' }}>{phoneText(locale, 'With Finley')}</span>
        <span>{phoneText(locale, 'Without plan')}</span>
      </div>
      <div className="relative h-1.5 rounded-full" style={{ background: 'rgba(9,20,16,0.08)' }}>
        <div className="absolute left-0 top-0 h-full rounded-full" style={{ width: '72%', background: 'linear-gradient(to right, #A8E1DF, #5D97D1)' }} />
        <div className="absolute w-2.5 h-2.5 rounded-full border-2 border-white" style={{ left: '72%', top: '50%', transform: 'translate(-50%, -50%)', background: '#5D97D1' }} />
        <div className="absolute w-2.5 h-2.5 rounded-full border-2 border-white" style={{ right: 0, top: '50%', transform: 'translateY(-50%)', background: 'rgba(9,20,16,0.2)' }} />
      </div>
      <div className="flex justify-between text-[8px] mt-1" style={{ color: 'rgba(9,20,16,0.4)' }}>
        <span>0 {phoneText(locale, 'mo')}</span>
        <span className="font-medium" style={{ color: '#5D97D1' }}>14 {phoneText(locale, 'mo')}</span>
        <span>18 {phoneText(locale, 'mo')}</span>
      </div>
    </div>
  </div>
);

const SpendingBreakdownTable = ({ locale }: { locale: PhoneLocale }) => {
  const rows = [
    { label: 'Food delivery', amount: '€127' },
    { label: 'Cafes', amount: '€67' },
    { label: 'Carsharing', amount: '€52' },
    { label: 'Streaming x3', amount: '€34' },
  ]

  return (
    <div className="rounded-lg p-2" style={{ background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(9,20,16,0.06)' }}>
      <div className="space-y-1.5">
        {rows.map(({ label, amount }, i) => (
          <div key={label}>
            <div className="flex justify-between items-center py-0.5">
              <span className="text-[9px]" style={{ color: 'rgba(9,20,16,0.55)' }}>{phoneText(locale, label)}</span>
              <span className="text-[9px] font-medium text-night">{amount}</span>
            </div>
            {i < rows.length - 1 && <div className="h-px" style={{ background: 'rgba(9,20,16,0.06)' }} />}
          </div>
        ))}
      </div>
    </div>
  )
}

const SpendingInsightCallout = ({ locale }: { locale: PhoneLocale }) => (
  <div className="rounded-lg overflow-hidden relative" style={{ background: 'rgba(197,236,172,0.25)', border: '1px solid rgba(197,236,172,0.6)' }}>
    <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: 'rgba(120,185,80,0.7)' }} />
    <div className="px-2 py-1.5 text-[11px] text-night leading-snug">
      {phoneText(locale, "That's €280 you probably didn't track. Cut half of this next month and you'll have")} <span className="font-semibold">€140</span> {phoneText(locale, 'more.')}
    </div>
  </div>
)

const AIWithSpendingBreakdown = ({ message, locale }: { message: Message; locale: PhoneLocale }) => (
  <div className="max-w-[95%] animate-in fade-in slide-in-from-bottom-4 duration-700 space-y-2">
    <div className="text-[11px] text-night leading-snug">{message.content}</div>
    <SpendingBreakdownTable locale={locale} />
    <SpendingInsightCallout locale={locale} />
  </div>
);

const UserMessage = ({ message }: { message: Message }) => (
  <div className="flex justify-end mt-3 animate-in fade-in slide-in-from-bottom-4 duration-500" key={message.id}>
                <div className="max-w-[90%] relative">
                  {/* Speech bubble with shadow */}
                  <div 
                    className="relative inline-block px-2 py-1.5"
                    style={{
                      backgroundColor: '#FAF9F5',
                      borderRadius: '16px 16px 0 16px',
                      filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))'
                    }}
                  >
                    <p className="text-[11px] text-night font-normal" style={{
                      fontFamily: 'var(--font-satoshi), sans-serif',
                      lineHeight: '1.3',
                      margin: 0
                    }}>
                      {message.content}
                    </p>
                  </div>
                </div>
              </div>
        );

const AIFinalMessage = ({ message, delayMs = 0 }: { message: Message; delayMs?: number }) => (
  <div
    className="max-w-[90%] animate-in fade-in slide-in-from-bottom-4 duration-500"
    key={message.id}
    style={{ animationDelay: `${delayMs}ms`, animationFillMode: 'both' }}
  >
    <div className="text-[11px] text-night leading-snug">
      {message.content}
            </div>
          </div>
        );
      
const SHARED_SCREENS_1_4: { id: number; messages: Message[] }[] = [
  { id: 1, messages: [{ id: '1', type: 'initial', content: 'Here if you need me.' }] },
  { id: 2, messages: [{ id: '1', type: 'with-glow', content: 'Hey, I spotted an opportunity for you. Should we discuss?' }] },
  { id: 3, messages: [{ id: '1', type: 'with-glow-chat', content: 'Hey, I spotted an opportunity for you. Should we discuss?' }] },
  { id: 4, messages: [{ id: '1', type: 'chat-collapsed' }] },
];

const SCREENS_BY_STAGE: Record<Stage, { id: number; messages: Message[] }[]> = {
  beginner: [
    { id: 5, messages: [
      { id: '1', type: 'user', content: "It's the 20th and I'm already broke. 10 more days to go 😭" }
    ]},
    { id: 6, messages: [
      { id: '1', type: 'user', content: "It's the 20th and I'm already broke. 10 more days to go 😭" },
      { id: '2', type: 'ai', thinking: true }
    ]},
    { id: 7, messages: [
      { id: '1', type: 'user', content: "It's the 20th and I'm already broke. 10 more days to go 😭" },
      { id: '2', type: 'ai-with-spending-breakdown', content: "Might be these this month so far:" }
    ]},
    { id: 8, messages: [
      { id: '1', type: 'user', content: "It's the 20th and I'm already broke. 10 more days to go 😭" },
      { id: '2', type: 'ai-with-spending-breakdown', content: "Might be these this month so far:" },
      { id: '3', type: 'user', content: ":/" },
      { id: '4', type: 'ai-final', content: "Want to set a monthly cap? I can warn you before you hit it." }
    ]}
  ],
  starting: [
    ...SHARED_SCREENS_1_4,
    { id: 5, messages: [
      { id: '1', type: 'ai', content: "Good news, your phone instalment clears in 14 months. Redirect that €15/month and your Dispo is gone 4 months sooner." },
      { id: '2', type: 'ai', thinking: true }
    ]},
    { id: 6, messages: [
      { id: '1', type: 'ai', content: "Good news, your phone instalment clears in 14 months. Redirect that €15/month and your Dispo is gone 4 months sooner." },
      { id: '2', type: 'ai-with-timeline', content: "Want to make that the plan?" }
    ]},
    { id: 7, messages: [
      { id: '1', type: 'ai', content: "Good news, your phone instalment clears in 14 months. Redirect that €15/month and your Dispo is gone 4 months sooner." },
      { id: '2', type: 'ai-with-timeline', content: "Want to make that the plan?" },
      { id: '3', type: 'user', content: "Sounds good. Let's put that to work." }
    ]},
    { id: 8, messages: [
      { id: '1', type: 'ai', content: "Good news, your phone instalment clears in 14 months. Redirect that €15/month and your Dispo is gone 4 months sooner." },
      { id: '2', type: 'ai-with-timeline', content: "Want to make that the plan?" },
      { id: '3', type: 'user', content: "Sounds good. Let's put that to work." },
      { id: '4', type: 'ai-final', content: 'Say no more.' }
    ]}
  ],
  organized: [
    ...SHARED_SCREENS_1_4,
    { id: 5, messages: [
      { id: '1', type: 'user', content: "Rent is starting to hurt. Could I realistically buy in the next few years?" }
    ]},
    { id: 6, messages: [
      { id: '1', type: 'user', content: "Rent is starting to hurt. Could I realistically buy in the next few years?" },
      { id: '2', type: 'ai', thinking: true }
    ]},
    { id: 7, messages: [
      { id: '1', type: 'user', content: "Rent is starting to hurt. Could I realistically buy in the next few years?" },
      { id: '2', type: 'ai-with-home-chart', content: "Yes. You are closer than it feels." }
    ]},
    { id: 8, messages: [
      { id: '1', type: 'user', content: "Rent is starting to hurt. Could I realistically buy in the next few years?" },
      { id: '2', type: 'ai-with-home-chart', content: "Yes. You are closer than it feels." },
      { id: '3', type: 'user', content: "That feels closer than I thought." }
    ]},
    { id: 9, messages: [
      { id: '1', type: 'user', content: "Rent is starting to hurt. Could I realistically buy in the next few years?" },
      { id: '2', type: 'ai-with-home-chart', content: "Yes. You are closer than it feels." },
      { id: '3', type: 'user', content: "That feels closer than I thought." },
      { id: '4', type: 'ai-final', content: "Let's create the goal and keep tracking your progress!" }
    ]}
  ],
  growing: [
    ...SHARED_SCREENS_1_4,
    { id: 5, messages: [
      { id: '1', type: 'ai', content: "I noticed you've got cash idling. €3,000 above your usual safety buffer." },
      { id: '2', type: 'ai', thinking: true }
    ]},
    { id: 6, messages: [
      { id: '1', type: 'ai', content: "I noticed you've got cash idling. €3,000 above your usual safety buffer." },
      { id: '2', type: 'ai-with-chart', content: 'You could put that money to work. For perspective: €3k invested in the MSCI World Index 5 years ago would be close to €5k today.' }
    ]},
    { id: 7, messages: [
      { id: '1', type: 'ai', content: "I noticed you've got cash idling. €3,000 above your usual safety buffer." },
      { id: '2', type: 'ai-with-chart', content: 'You could put that money to work. For perspective: €3k invested in the MSCI World Index 5 years ago would be close to €5k today.' },
      { id: '3', type: 'user', content: "Sounds good. Let's put that to work." }
    ]},
    { id: 8, messages: [
      { id: '1', type: 'ai', content: "I noticed you've got cash idling. €3,000 above your usual safety buffer." },
      { id: '2', type: 'ai-with-chart', content: 'You could put that money to work. For perspective: €3k invested in the MSCI World Index 5 years ago would be close to €5k today.' },
      { id: '3', type: 'user', content: "Sounds good. Let's put that to work." },
      { id: '4', type: 'ai-final', content: 'Say no more.' }
    ]}
  ],
};

const TRANSITION_23_MS = 700;
const TEXT_APPEAR_DELAY_MS = 350;
const TRANSITION_34_MS = 700;
const AUTO_CYCLE_DEFAULT_MS = 4000;
const AUTO_CYCLE_SCREEN1_MS = 500;
const AUTO_CYCLE_SCREEN2_MS = 1000;
const AUTO_CYCLE_SCREEN4_MS = 800;
const AUTO_CYCLE_BEGINNER_EMPTY_MS = 1200;
const AUTO_CYCLE_BEGINNER_USER_MS = 700;
const AUTO_CYCLE_BEGINNER_THINKING_MS = 900;
const AUTO_CYCLE_ORGANIZED_EMPTY_MS = 1200;
const AUTO_CYCLE_ORGANIZED_USER_MS = 700;
const AUTO_CYCLE_ORGANIZED_THINKING_MS = 900;
const AUTO_CYCLE_ORGANIZED_REACTION_MS = 900;
const AUTO_CYCLE_SCREEN8_MS = 8000;

type Stage = 'starting' | 'beginner' | 'organized' | 'growing'
type PhoneLocale = 'en' | 'de'

const PHONE_TEXT_DE: Record<string, string> = {
  'Here if you need me.': 'Ich bin da, wenn du mich brauchst.',
  'Here if you need me!': 'Ich bin da, wenn du mich brauchst!',
  'Hey, I spotted an opportunity for you.': 'Hey, ich habe eine Möglichkeit entdeckt.',
  'Hey, I spotted an opportunity for you. Should we discuss?': 'Hey, ich habe eine Möglichkeit für dich entdeckt. Wollen wir sie anschauen?',
  "It's the 20th and I'm already broke. 10 more days to go 😭": 'Es ist der 20. und ich bin schon blank. Noch 10 Tage 😭',
  'Might be these this month so far:': '👀',
  ':/': ':/',
  "Want to set a monthly cap? I can warn you before you hit it.": 'Monatslimit setzen? Ich warne dich vorher.',
  'Good news, your phone instalment clears in 14 months. Redirect that €15/month and your Dispo is gone 4 months sooner.': 'Gute Nachricht: Deine Handy-Ratenzahlung ist in 14 Monaten durch. Wenn du die 15 €/Monat umleitest, ist dein Dispo 4 Monate früher weg.',
  'Want to make that the plan?': 'Sollen wir daraus den Plan machen?',
  "Sounds good. Let's put that to work.": 'Klingt gut. Lass uns das nutzen.',
  'Say no more.': 'Alles klar.',
  'Rent is starting to hurt. Could I realistically buy in the next few years?': 'Die Miete tut langsam weh. Könnte ich in den nächsten Jahren realistisch kaufen?',
  'Yes. You are closer than it feels.': 'Ja. Du bist näher dran, als es sich anfühlt.',
  'That feels closer than I thought.': 'Das fühlt sich näher an, als ich dachte.',
  "Let's create the goal and keep tracking your progress!": 'Lass uns das Ziel anlegen und deinen Fortschritt weiter verfolgen!',
  "I noticed you've got cash idling. €3,000 above your usual safety buffer.": 'Mir ist aufgefallen, dass Geld ungenutzt herumliegt. 3.000 € über deinem üblichen Sicherheitspuffer.',
  'You could put that money to work. For perspective: €3k invested in the MSCI World Index 5 years ago would be close to €5k today.': 'Du könntest dieses Geld arbeiten lassen. Zur Einordnung: 3.000 € im MSCI World vor 5 Jahren wären heute fast 5.000 €.',
  'Assuming a €70k down payment and your current savings rate, you\'ll be in your own home in 4 to 5 years. Almost no time.': 'Mit 70.000 € Eigenkapital und deiner aktuellen Sparrate könntest du in 4 bis 5 Jahren im eigenen Zuhause sein. Gar nicht mehr so weit weg.',
  "That's €280 you probably didn't track. Cut half of this next month and you'll have": 'Das sind 280 €, die leicht untergehen. Halbierst du das nächsten Monat, bleiben',
  'more.': 'mehr.',
  'Food delivery': 'Lieferessen',
  'Cafes': 'Cafés',
  'Carsharing': 'Carsharing',
  'Streaming x3': 'Streaming x3',
  'Today': 'Heute',
  'With Finley': 'Mit Finley',
  'Without plan': 'Ohne Plan',
  'Projected income': 'Progn. Einkommen',
  'Estimated need': 'Geschätzter Bedarf',
  'Index fund': 'Indexfonds',
  'Yr': 'J',
  'Gap': 'Lücke',
  'mo': 'Mon.',
  '€34k saved': '34 Tsd. € gespart',
  '€70k goal': '70 Tsd. € Ziel',
  'Cash accounts': 'Geldkonten',
  'Investment accounts': 'Investments',
  'Liabilities': 'Verbindlichkeiten',
  'Tagesgeld savings': 'Tagesgeld',
  'Current account': 'Girokonto',
  'Savings': 'Sparkonto',
  'Dispo (overdraft)': 'Dispo',
  'Phone installment': 'Handyrate',
  'Personal loan': 'Privatkredit',
  'Pension': 'Rente',
  'Capital': 'Depot',
  'Main': 'Girokonto',
  'Stock': 'Aktien',
  'Student loan': 'Studienkredit',
  'Home': 'Home',
  'Tomorrow': 'Morgen',
  'Flow': 'Flow',
}

const phoneText = (locale: PhoneLocale, text: string) => (locale === 'de' ? PHONE_TEXT_DE[text] || text : text)

const getFirstScreenForStage = (stage: Stage) => {
  if (stage === 'beginner') return 4
  if (stage === 'organized') return 4
  return 1
}
const getLastScreenForStage = (stage: Stage) => SCREENS_BY_STAGE[stage].at(-1)?.id ?? 8

const STAGE_DATA: Record<Stage, {
  totalBalance: string
  cashAccounts: { amount: string; label: string }[]
  investmentAccounts: { amount: string; label: string }[]
  liabilities: { amount: string; label: string }[]
}> = {
  beginner: {
    totalBalance: '€5,850',
    cashAccounts: [
      { amount: '€5,000', label: 'Tagesgeld savings' },
      { amount: '€850', label: 'Current account' },
    ],
    investmentAccounts: [],
    liabilities: [
      { amount: '€100', label: 'Kreditkarte' },
    ],
  },
  starting: {
    totalBalance: '-€600',
    cashAccounts: [
      { amount: '€640', label: 'N26' },
      { amount: '€600', label: 'Savings' },
    ],
    investmentAccounts: [],
    liabilities: [
      { amount: '€380', label: 'Dispo (overdraft)' },
      { amount: '€290', label: 'Klarna' },
      { amount: '€180', label: 'Phone installment' },
      { amount: '€990', label: 'Personal loan' },
    ],
  },
  organized: {
    totalBalance: '€1,700',
    cashAccounts: [
      { amount: '€1,600', label: 'Current account' },
      { amount: '€2,200', label: 'Tagesgeld savings' },
    ],
    investmentAccounts: [
      { amount: '€2,800', label: 'Pension' },
      { amount: '€1,300', label: 'Capital' },
    ],
    liabilities: [
      { amount: '€5,800', label: 'Ratenkredit' },
      { amount: '€400', label: 'Dispo' },
    ],
  },
  growing: {
    totalBalance: '€7,400',
    cashAccounts: [
      { amount: '€1,600', label: 'Main' },
      { amount: '€4,500', label: 'Savings' },
    ],
    investmentAccounts: [
      { amount: '€2,400', label: 'ETFs' },
      { amount: '€800', label: 'Stock' },
    ],
    liabilities: [
      { amount: '€2,000', label: 'Student loan' },
    ],
  },
}

export default function PhoneMockup({ stage = 'starting', locale = 'en' }: { stage?: Stage; locale?: string }) {
  const phoneLocale: PhoneLocale = locale === 'de' ? 'de' : 'en'
  const baseData = STAGE_DATA[stage]
  const data = {
    ...baseData,
    cashAccounts: baseData.cashAccounts.map(account => ({ ...account, label: phoneText(phoneLocale, account.label) })),
    investmentAccounts: baseData.investmentAccounts.map(account => ({ ...account, label: phoneText(phoneLocale, account.label) })),
    liabilities: baseData.liabilities.map(account => ({ ...account, label: phoneText(phoneLocale, account.label) })),
  }
  const [currentScreen, setCurrentScreen] = useState(() => getFirstScreenForStage(stage));
  const [isAutoCycling, setIsAutoCycling] = useState(true);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const prevScreenRef = useRef<number>(currentScreen);
  const [isTransitioning23, setIsTransitioning23] = useState(false);
  const [transitionArmed, setTransitionArmed] = useState(false);
  const [showTransitionText, setShowTransitionText] = useState(false);

  // Transition state for screens 3 → 4
  const [isTransitioning34, setIsTransitioning34] = useState(false);
  const [transitionArmed34, setTransitionArmed34] = useState(false);
  const [transitionCompleted34, setTransitionCompleted34] = useState(false);

  const screens = SCREENS_BY_STAGE[stage]
  const messages = (screens.find(s => s.id === currentScreen)?.messages ?? []).map(message => ({
    ...message,
    content: message.content ? phoneText(phoneLocale, message.content) : message.content,
  }));
  const bottomNavCopy = {
    collapsedText: phoneText(phoneLocale, 'Here if you need me!'),
    chatPreviewText: phoneText(phoneLocale, 'Hey, I spotted an opportunity for you.'),
    navLabels: {
      home: phoneText(phoneLocale, 'Home'),
      tomorrow: phoneText(phoneLocale, 'Tomorrow'),
      flow: phoneText(phoneLocale, 'Flow'),
    },
  }

  useEffect(() => {
    setCurrentScreen(getFirstScreenForStage(stage))
    setIsAutoCycling(true)
  }, [stage]);

  /* eslint-disable react-hooks/set-state-in-effect -- animation state machine requires synchronous setState based on screen transitions */
  useEffect(() => {
    const prev = prevScreenRef.current;
    const timeouts: number[] = [];

    // Handle transition from screen 2 → 3
    if (prev === 2 && currentScreen === 3) {
      setIsTransitioning23(true);
      setTransitionArmed(false);
      setShowTransitionText(false);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setTransitionArmed(true));
      });
      const textTimer = window.setTimeout(() => {
        setShowTransitionText(true);
      }, TEXT_APPEAR_DELAY_MS);
      const t = window.setTimeout(() => {
        setIsTransitioning23(false);
        setTransitionArmed(false);
        setShowTransitionText(false);
      }, TRANSITION_23_MS);
      timeouts.push(textTimer, t);
    }

    // Handle transition from screen 3 → 4 - ALWAYS trigger animation
    if (prev === 3 && currentScreen === 4) {
      setIsTransitioning34(true);
      setTransitionArmed34(false);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setTransitionArmed34(true));
      });
      const t = window.setTimeout(() => {
        setIsTransitioning34(false);
        setTransitionArmed34(false);
        setTransitionCompleted34(true); // keep final positions
      }, TRANSITION_34_MS);
      timeouts.push(t);
    }

    // When jumping directly to screen 4 (not from 3), show final state immediately
    if (prev !== 3 && prev !== 4 && currentScreen === 4) {
      setIsTransitioning34(false);
      setTransitionArmed34(false);
      setTransitionCompleted34(true);
    }

    // Reset ALL states when leaving screen 4 - ensures animation runs next time
    if (prev === 4 && currentScreen !== 4) {
      setIsTransitioning34(false);
      setTransitionArmed34(false);
      setTransitionCompleted34(false);
    }
    // Also reset at the start of the loop (when going from 8 to 1)
    if (prev === 8 && currentScreen === 1) {
      setIsTransitioning34(false);
      setTransitionArmed34(false);
      setTransitionCompleted34(false);
    }

    // Always update prev after handling transitions
    prevScreenRef.current = currentScreen;

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [currentScreen]);
  /* eslint-enable react-hooks/set-state-in-effect */

  

  // Auto-cycling through screens (with special durations for screens 1, 2, 4, and 8)
  useEffect(() => {
    if (!isAutoCycling) return;

    let delay = AUTO_CYCLE_DEFAULT_MS;
    if (stage === 'beginner' && currentScreen === 4) {
      delay = AUTO_CYCLE_BEGINNER_EMPTY_MS;
    } else if (stage === 'beginner' && currentScreen === 5) {
      delay = AUTO_CYCLE_BEGINNER_USER_MS;
    } else if (stage === 'beginner' && currentScreen === 6) {
      delay = AUTO_CYCLE_BEGINNER_THINKING_MS;
    } else if (stage === 'organized' && currentScreen === 4) {
      delay = AUTO_CYCLE_ORGANIZED_EMPTY_MS;
    } else if (stage === 'organized' && currentScreen === 5) {
      delay = AUTO_CYCLE_ORGANIZED_USER_MS;
    } else if (stage === 'organized' && currentScreen === 6) {
      delay = AUTO_CYCLE_ORGANIZED_THINKING_MS;
    } else if (stage === 'organized' && currentScreen === 8) {
      delay = AUTO_CYCLE_ORGANIZED_REACTION_MS;
    } else if (stage === 'organized' && currentScreen === 9) {
      delay = AUTO_CYCLE_SCREEN8_MS;
    } else if (currentScreen === 1) {
      delay = AUTO_CYCLE_SCREEN1_MS;
    } else if (currentScreen === 2) {
      delay = AUTO_CYCLE_SCREEN2_MS;
    } else if (currentScreen === 4) {
      delay = AUTO_CYCLE_SCREEN4_MS;
    } else if (currentScreen === 8) {
      delay = AUTO_CYCLE_SCREEN8_MS;
    }
    
    const t = window.setTimeout(() => {
      setCurrentScreen((prev) => (
        prev >= getLastScreenForStage(stage) ? getFirstScreenForStage(stage) : prev + 1
      ));
    }, delay);

    return () => clearTimeout(t);
  }, [isAutoCycling, currentScreen, stage]);

  const renderChatInterface = () => {
    const hasInitialMessage = messages.some(m => m.type === 'initial' || m.type === 'with-glow' || m.type === 'with-glow-chat' || m.type === 'chat-collapsed');
    
    if (hasInitialMessage) {
      const message = messages[0];
      // Map initial messages to bottom nav states
      // Special collapsed chat preview
      if (message.type === 'chat-collapsed') {
        return (
          <div className="absolute inset-x-0 top-10">
            <div
              className="mx-2"
              style={{
                height: 26,
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                border: '1px solid rgba(255,255,255,0.9)',
                background: 'rgba(255,255,255,0.35)',
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)',
                boxShadow: '0 6px 14px rgba(0,0,0,0.08)'
              }}
            >
              <div className="flex justify-center pt-2">
                <div className="w-12 h-1.5 bg-gray-400 rounded-full opacity-40"></div>
              </div>
            </div>
          </div>
        );
      }

      let state: BottomNavState = 'nav';
      if (message.type === 'with-glow') state = 'nav-notify';
      if (message.type === 'with-glow-chat') state = 'chat-notify';
      
      // Special visual-only transition for 2 -> 3 to slow the perceived switch
      if (isTransitioning23 && currentScreen === 3) {
        const easing = 'cubic-bezier(0.22,1,0.36,1)';
        const durationMs = TRANSITION_23_MS + 'ms';
        return (
          <div className="mt-auto relative">
            {/* Previous (screen 2) nav fading out */}
            <div
              className="absolute inset-x-0 bottom-0"
              style={{
                transition: `opacity ${durationMs} ${easing}, transform ${durationMs} ${easing}`,
                opacity: transitionArmed ? 0 : 1,
                transform: transitionArmed ? 'translateY(8px)' : 'translateY(0px)'
              }}
            >
              <BottomChatNav state="nav-notify" {...bottomNavCopy} />
            </div>
            {/* New (screen 3) nav fading in */}
            <div
              className="relative"
              style={{
                transition: `opacity ${durationMs} ${easing}, transform ${durationMs} ${easing}`,
                opacity: transitionArmed ? 1 : 0,
                transform: transitionArmed ? 'translateY(0px)' : 'translateY(-8px)'
              }}
            >
              <BottomChatNav
                state="chat-notify"
                {...bottomNavCopy}
                hideChatText={false}
                chatTextStyle={{
                  transition: `opacity ${durationMs} ${easing}`,
                  opacity: showTransitionText ? 1 : 0
                }}
              />
            </div>
          </div>
        );
      }
      
      return (
        <div className="mt-auto">
          <BottomChatNav state={state} {...bottomNavCopy} />
        </div>
      );
    }

    // Full chat interface
        return (
          <div className="absolute inset-x-0 bottom-0 top-10 bg-baby-powder rounded-lg">
            {/* Drag Bar */}
            <div className="flex justify-center py-2">
              <div className="w-8 h-1 bg-gray-400 rounded-full"></div>
            </div>
            
            {/* Chat Messages */}
            <div className="px-4 py-3 space-y-2">
          {messages.map((message, index) => {
            switch (message.type) {
              case 'ai':
                if (message.thinking) {
                  return <ThinkingIndicator key={message.id} />;
                }
                return <AIMessage key={message.id} message={message} />;
              case 'ai-with-chart':
                return <AIWithChart key={message.id} message={message} />;
              case 'ai-with-gap-chart':
                return <AIWithGapChart key={message.id} message={message} locale={phoneLocale} />;
              case 'ai-with-home-chart':
                return <AIWithHomeChart key={message.id} message={message} locale={phoneLocale} />;
              case 'ai-with-timeline':
                return <AIWithTimeline key={message.id} message={message} locale={phoneLocale} />;
              case 'ai-with-spending-breakdown':
                return <AIWithSpendingBreakdown key={message.id} message={message} locale={phoneLocale} />;
              case 'user':
                return <UserMessage key={message.id} message={message} />;
              case 'ai-final':
                return <AIFinalMessage key={message.id} message={message} delayMs={messages[index - 1]?.type === 'user' ? 650 : 0} />;
              default:
                return null;
            }
          })}
          <div ref={messagesEndRef} />
            </div>
          </div>
        );
  };

  return (
    <div className="relative flex flex-col items-center">
      {/* Dev Controls - outside the phone */}
      {/* <div className="mb-3 bg-white bg-opacity-90 rounded-lg p-2 shadow-lg z-50">
        <div className="text-xs text-night mb-2">Screen: {currentScreen}</div>
        <div className="flex gap-1 mb-2">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
            <button 
              key={num}
              onClick={() => {
                setIsAutoCycling(false);
                setCurrentScreen(num);
              }}
              className={`px-2 py-1 text-xs rounded ${currentScreen === num ? 'bg-night text-white' : 'bg-gray-200 text-night'}`}
            >
              {num}
            </button>
          ))}
        </div>
        <button
          onClick={() => setIsAutoCycling(!isAutoCycling)}
          className={`w-full px-3 py-1.5 text-xs rounded ${
            isAutoCycling ? 'bg-green-500 text-white' : 'bg-gray-200 text-night'
          }`}
        >
          {isAutoCycling ? '⏸ Auto' : '▶ Auto'}
        </button>
      </div> */}

      <div className="phone-mockup">
      <div className="phone-notch"></div>
      <div className="phone-screen">
        {/* Screen 4: empty preview with line and drag bar */}
        {currentScreen === 4 ? (
        <div className="relative w-full h-full flex flex-col">
            {/* Whitish line across the full inner width, ~90% from bottom - animated on transition */}
            <div
              className="absolute left-[-25px] right-[-25px]"
              style={{ 
                height: 1, 
                background: 'rgba(255,255,255,0.95)', 
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                bottom: transitionArmed34 || transitionCompleted34 ? '95%' : '20%',
                transition: `opacity ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1), bottom ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1)`,
                opacity: transitionArmed34 || transitionCompleted34 ? 1 : 0
              }}
            />
            {/* Subtle grey drag bar just below the line - animated on transition */}
            <div
              className="absolute left-1/2"
              style={{ 
                width: 50, 
                height: 3, 
                borderRadius: 9999, 
                background: 'rgba(0,0,0,0.28)',
                bottom: transitionArmed34 || transitionCompleted34 ? 'calc(95% - 12px)' : 'calc(20% - 12px)',
                transform: 'translateX(-50%)',
                transition: `opacity ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1), bottom ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1)`,
                opacity: transitionArmed34 || transitionCompleted34 ? 1 : 0
              }}
            />
            {/* Bottom navigation with transition for 3 -> 4 */}
            {isTransitioning34 ? (
              <div className="mt-auto relative">
                {/* Previous (screen 3) nav fading out */}
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    transition: `opacity ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1), transform ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1)`,
                    opacity: transitionArmed34 ? 0 : 1,
                    transform: transitionArmed34 ? 'translateY(8px)' : 'translateY(0px)'
                  }}
                >
                  <BottomChatNav state="chat-notify" {...bottomNavCopy} />
                </div>
                {/* New (screen 4) nav fading in */}
                <div
                  className="relative"
                  style={{
                    transition: `opacity ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1), transform ${TRANSITION_34_MS}ms cubic-bezier(0.22,1,0.36,1)`,
                    opacity: transitionArmed34 ? 1 : 0,
                    transform: transitionArmed34 ? 'translateY(0px)' : 'translateY(-8px)'
                  }}
                >
                  <BottomChatNav state="chat-input" {...bottomNavCopy} />
                </div>
              </div>
            ) : (
              <div className="mt-auto">
                <BottomChatNav state="chat-input" {...bottomNavCopy} />
              </div>
            )}
          </div>
        ) : currentScreen >= 5 ? (
          // Screens 5-8: use the Screen 4 background and render messages with same nav as screen 4
          <div className="relative w-full h-full flex flex-col">
            <div
              className="absolute left-[-25px] right-[-25px]"
              style={{ bottom: '95%', height: 1, background: 'rgba(255,255,255,0.95)', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}
            />
            <div
              className="absolute left-1/2"
              style={{ bottom: 'calc(95% - 12px)', transform: 'translateX(-50%)', width: 50, height: 3, borderRadius: 9999, background: 'rgba(0,0,0,0.28)' }}
            />
            {/* Messages stack - reuse exact padding and flow from the full chat UI */}
            <div className="absolute inset-x-0" style={{ top: 'calc(1% + 30px)' }}>
              <div className="px-0 space-y-3">
                {messages.map((message, index) => {
                  switch (message.type) {
                    case 'ai':
                      if (message.thinking) return <ThinkingIndicator key={message.id} />;
                      return <AIMessage key={message.id} message={message} />;
                    case 'ai-with-chart':
                      return <AIWithChart key={message.id} message={message} />;
                    case 'ai-with-comparison-chart':
                      return <AIWithComparisonChart key={message.id} message={message} locale={phoneLocale} />;
                    case 'ai-with-gap-chart':
                      return <AIWithGapChart key={message.id} message={message} locale={phoneLocale} />;
                    case 'ai-with-home-chart':
                      return <AIWithHomeChart key={message.id} message={message} locale={phoneLocale} />;
                    case 'ai-with-timeline':
                      return <AIWithTimeline key={message.id} message={message} locale={phoneLocale} />;
                    case 'ai-with-spending-breakdown':
                      return <AIWithSpendingBreakdown key={message.id} message={message} locale={phoneLocale} />;
                    case 'user':
                      return <UserMessage key={message.id} message={message} />;
                    case 'ai-final':
                      return <AIFinalMessage key={message.id} message={message} delayMs={messages[index - 1]?.type === 'user' ? 650 : 0} />;
                    default:
                      return null;
                  }
                })}
                <div ref={messagesEndRef} />
              </div>
            </div>
            {/* Bottom navigation identical to screen 4 */}
            <div className="mt-auto">
              <BottomChatNav state="chat-input" {...bottomNavCopy} />
            </div>
          </div>
        ) : (
        /* Financial Dashboard Content */
        <div className="flex flex-col h-full text-night">
          {/* Total Balance */}
          <div className="text-center mb-4">
            <div className="text-2xl font-medium mb-2">{data.totalBalance}</div>
            <svg width="321" height="72" viewBox="0 0 321 72" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
              {stage === 'beginner' ? (
                <path d="M0 42C12.3122 42 12.3122 41 24.6244 41C36.9366 41 36.9366 43 49.2488 43C61.5609 43 61.5609 42 73.8731 42C86.1853 42 86.1853 40 98.4975 40C111.266 40 111.266 41 124.034 41C135.890 41 135.890 40 147.746 40C158.463 40 158.463 39 169.179 39C183.087 39 183.087 40 196.995 40C208.851 40 208.851 39 220.707 39C233.476 39 233.476 38 246.244 38C259.468 38 259.468 37 272.692 37C284.093 37 284.093 38 295.493 38C307.805 38 307.805 36 320.117 36" stroke="url(#paint0_linear_1134_2608)" strokeWidth="2.73604"/>
              ) : (
                <path d="M0 70.3381C12.3122 70.3381 12.3122 56.7904 24.6244 56.7904C36.9366 56.7904 36.9366 53.7114 49.2488 53.7114C61.5609 53.7114 61.5609 56.7904 73.8731 56.7904C86.1853 56.7904 86.1853 55.5588 98.4975 55.5588C110.81 55.5588 111.722 41.4967 124.034 41.4967C136.346 41.4967 135.434 70.3381 147.746 70.3381C160.058 70.3381 156.866 28.4634 169.179 28.4634C181.491 28.4634 184.683 62.9485 196.995 62.9485C209.307 62.9485 208.395 41.4967 220.707 41.4967C233.02 41.4967 233.932 48.785 246.244 48.785C258.556 48.785 260.38 13.6841 272.692 13.6841C285.004 13.6841 283.18 13.6841 295.493 13.6841C307.805 13.6841 307.805 1.36803 320.117 1.36803" stroke="url(#paint0_linear_1134_2608)" strokeWidth="2.73604"/>
              )}
              <defs>
                <linearGradient id="paint0_linear_1134_2608" x1="0" y1="37.3926" x2="320.117" y2="37.3926" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#A8E1DF"/>
                  <stop offset="0.5" stopColor="#C5ECAC"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          
          {/* Cash Accounts */}
          <div className="mb-4">
            <h3 className="text-sm font-regular mb-2 text-night">{phoneText(phoneLocale, 'Cash accounts')}</h3>
            <div className="flex gap-2 mb-2">
              <div className="flex-1 rounded-lg px-3 py-2 text-xs font-sans text-night shadow-sm" style={{ background: 'linear-gradient(to bottom, var(--baby-powder), rgba(168, 225, 223, 0.3))', boxShadow: '0 6px 14px rgba(0,0,0,0.12)' }}>
                <div className="font-regular">{data.cashAccounts[0].amount}</div>
                <div className="text-xs opacity-60">{data.cashAccounts[0].label}</div>
              </div>
              <div className="flex-1 rounded-lg px-3 py-2 text-xs font-sans text-night shadow-sm" style={{ background: 'linear-gradient(to bottom, var(--baby-powder), rgba(168, 225, 223, 0.3))', boxShadow: '0 6px 14px rgba(0,0,0,0.12)' }}>
                <div className="font-regular">{data.cashAccounts[1].amount}</div>
                <div className="text-xs opacity-60">{data.cashAccounts[1].label}</div>
              </div>
            </div>
          </div>
          
          {/* Investment Accounts */}
          {data.investmentAccounts.length > 0 && (
            <div className="mb-4">
              <h3 className="text-sm font-regular mb-2 text-night">{phoneText(phoneLocale, 'Investment accounts')}</h3>
              <div className="flex gap-2 mb-2">
                {data.investmentAccounts.map((acc) => (
                  <div key={acc.label} className="flex-1 rounded-lg px-3 py-2 text-xs font-sans text-night shadow-sm" style={{ background: 'linear-gradient(to bottom, var(--baby-powder), rgba(136, 199, 219, 0.1))', boxShadow: '0 6px 14px rgba(0,0,0,0.12)' }}>
                    <div className="font-regular">{acc.amount}</div>
                    <div className="text-xs opacity-60">{acc.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* Liabilities */}
          {data.liabilities.length > 0 && (
            <div className="mb-4">
              <h3 className="text-sm font-regular mb-2 text-night">{phoneText(phoneLocale, 'Liabilities')}</h3>
              <div className="flex flex-wrap gap-2 mb-2">
                {data.liabilities.map((liability) => (
                  <div key={liability.label} className="rounded-lg px-3 py-2 text-xs font-sans text-night shadow-sm" style={{ width: 'calc(50% - 4px)', background: 'linear-gradient(to bottom, var(--baby-powder), rgba(255, 107, 107, 0.1))', boxShadow: '0 6px 14px rgba(0,0,0,0.12)' }}>
                    <div className="font-regular">{liability.amount}</div>
                    <div className="text-xs opacity-60">{liability.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* Chat Interface */}
          {renderChatInterface()}
        </div>
        )}
      </div>
      
    </div>
    </div>
  );
}
